// 자동 생성 파일 — public/ 안 이미지의 실제 픽셀 크기.
// 다시 만들려면: npm run image-sizes

export const imageSizes = {
  "/images/cases/gimcheon.webp": [1672, 941],
  "/images/cases/gochang.webp": [1590, 989],
  "/images/cases/jindo.webp": [1448, 1086],
  "/images/cases/jinju.webp": [1448, 1086],
  "/images/cases/namwon.webp": [1144, 643],
  "/images/cinderella-story.jpg": [1080, 1203],
  "/images/duck-program.webp": [1800, 518],
  "/images/group-visits/01.webp": [1800, 1350],
  "/images/group-visits/02.webp": [1012, 1800],
  "/images/group-visits/03.webp": [1800, 1350],
  "/images/group-visits/04.webp": [1800, 1350],
  "/images/group-visits/05.webp": [1012, 1800],
  "/images/group-visits/06.webp": [1012, 1800],
  "/images/group-visits/07.webp": [1012, 1800],
  "/images/group-visits/08.webp": [1012, 1800],
  "/images/group-visits/09.webp": [1012, 1800],
  "/images/group-visits/10.webp": [1012, 1800],
  "/images/group-visits/11.webp": [1350, 1800],
  "/images/group-visits/12.webp": [1012, 1800],
  "/images/group-visits/13.webp": [1012, 1800],
  "/images/group-visits/14.webp": [1012, 1800],
  "/images/group-visits/15.webp": [1012, 1800],
  "/images/group-visits/16.webp": [1012, 1800],
  "/images/group-visits/17.webp": [1012, 1800],
  "/images/group-visits/18.webp": [1012, 1800],
  "/images/group-visits/19.webp": [1012, 1800],
  "/images/group-visits/20.webp": [1012, 1800],
  "/images/group-visits/21.webp": [1012, 1800],
  "/images/group-visits/22.webp": [1012, 1800],
  "/images/group-visits/23.webp": [976, 1738],
  "/images/group-visits/24.webp": [1012, 1800],
  "/images/group-visits/25.webp": [1008, 1790],
  "/images/group-visits/26.webp": [1012, 1800],
  "/images/group-visits/27.webp": [1012, 1800],
  "/images/group-visits/28.webp": [942, 1676],
  "/images/group-visits/29.webp": [928, 1652],
  "/images/group-visits/30.webp": [1012, 1800],
  "/images/group-visits/31.webp": [790, 1394],
  "/images/group-visits/32.webp": [1012, 1800],
  "/images/group-visits/33.webp": [956, 1724],
  "/images/group-visits/34.webp": [1012, 1800],
  "/images/group-visits/35.webp": [1012, 1800],
  "/images/group-visits/36.webp": [1012, 1800],
  "/images/group-visits/37.webp": [1012, 1800],
  "/images/group-visits/38.webp": [1800, 1013],
  "/images/group-visits/39.webp": [1012, 1800],
  "/images/group-visits/40.webp": [1800, 1013],
  "/images/group-visits/41.webp": [1800, 1013],
  "/images/group-visits/42.webp": [1012, 1800],
  "/images/group-visits/43.webp": [1012, 1800],
  "/images/group-visits/44.webp": [1012, 1800],
  "/images/group-visits/45-phone-blurred.webp": [1086, 1448],
  "/images/group-visits/46.webp": [1012, 1800],
  "/images/group-visits/47.webp": [1800, 1350],
  "/images/group-visits/48.webp": [1800, 1350],
  "/images/group-visits/49.webp": [1800, 1350],
  "/images/group-visits/50.webp": [988, 1758],
  "/images/group-visits/51.webp": [1012, 1800],
  "/images/group-visits/52.webp": [1012, 1800],
  "/images/group-visits/53.webp": [1012, 1800],
  "/images/hero-institution.webp": [1800, 1013],
  "/images/hero-visit.webp": [2200, 1650],
  "/images/instrument-experience.webp": [956, 1255],
  "/images/media-art-live.jpg": [4000, 2226],
  "/images/participation.webp": [1080, 1087],
  "/images/public-hall.webp": [1600, 1200],
  "/images/storytelling.webp": [1080, 1350],
  "/images/venue-wide.webp": [1800, 1002],
  "/images/venue-starry-night.jpg": [1810, 1080],
  "/images/winter-program.webp": [1800, 1013],
  "/my-little-classic-logo.png": [1983, 793],
};

// <img {...imageSize(src)} /> 형태로 width·height를 붙여 CLS를 방지합니다.
export function imageSize(src) {
  const size = imageSizes[src];
  return size ? { width: size[0], height: size[1] } : {};
}
